// extracted by mini-css-extract-plugin
export default {"clipped":"colors__clipped--EqrBg","silence":"colors__silence--w0L3x","high":"colors__high--njFNi","low":"colors__low--eqW2U","bar":"colors__bar--hMLQD"};